"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveStateParam = exports.createStateWithParamClassName = exports.createBooleanStateClassName = exports.setStateToNode = exports.validateStateArgument = exports.validateStateDefinition = exports.processPseudoStates = exports.stateErrors = exports.stateWithParamDelimiter = exports.booleanStateDelimiter = exports.stateMiddleDelimiter = void 0;
const postcss_value_parser_1 = __importDefault(require("postcss-value-parser"));
const functions_1 = require("./functions");
const selector_1 = require("./helpers/selector");
const deprecation_1 = require("./helpers/deprecation");
const value_1 = require("./helpers/value");
const state_validators_1 = require("./state-validators");
const features_1 = require("./features");
const string_1 = require("./helpers/string");
const native_reserved_lists_1 = require("./native-reserved-lists");
const cssesc_1 = __importDefault(require("cssesc"));
exports.stateMiddleDelimiter = '-';
exports.booleanStateDelimiter = '--';
exports.stateWithParamDelimiter = exports.booleanStateDelimiter + exports.stateMiddleDelimiter;
exports.stateErrors = {
    UNKNOWN_STATE_USAGE: (name) => `unknown pseudo-state "${name}"`,
    UNKNOWN_STATE_TYPE: (name, type) => `pseudo-state "${name}" defined with unknown type: "${type}"`,
    TOO_MANY_STATE_TYPES: (name, types) => `pseudo-state "${name}(${types.join(', ')})" definition must be of a single type`,
    NO_STATE_ARGUMENT_GIVEN: (name, type) => `pseudo-state "${name}" expected argument of type "${type}" but got none`,
    NO_STATE_TYPE_GIVEN: (name) => `pseudo-state "${name}" expected a definition of a single type, but received none`,
    TOO_MANY_ARGS_IN_VALIDATOR: (name, validator, args) => `pseudo-state "${name}" expected "${validator}" validator to receive a single argument, but it received "${args.join(', ')}"`,
    STATE_STARTS_WITH_HYPHEN: (name) => `state "${name}" declaration cannot begin with a "${exports.stateMiddleDelimiter}" character`,
    RESERVED_NATIVE_STATE: (name) => `state "${name}" is reserved for native pseudo-class`,
};
// PROCESS
function processPseudoStates(value, decl, diagnostics) {
    const mappedStates = {};
    const ast = (0, postcss_value_parser_1.default)(value);
    const statesSplitByComma = (0, value_1.groupValues)(ast.nodes);
    statesSplitByComma.forEach((workingState) => {
        const [stateDefinition, ...stateDefault] = workingState;
        if (stateDefinition.value.startsWith('-')) {
            diagnostics.error(decl, exports.stateErrors.STATE_STARTS_WITH_HYPHEN(stateDefinition.value), {
                word: stateDefinition.value,
            });
        }
        else if (native_reserved_lists_1.reservedFunctionalPseudoClasses.includes(stateDefinition.value)) {
            diagnostics.warn(decl, exports.stateErrors.RESERVED_NATIVE_STATE(stateDefinition.value), {
                word: stateDefinition.value,
            });
            return;
        }
        if (stateDefinition.type === 'function') {
            resolveStateType(stateDefinition, mappedStates, stateDefault, diagnostics, decl);
        }
        else if (stateDefinition.type === 'word') {
            resolveBooleanState(mappedStates, stateDefinition);
        }
        else {
            // TODO: Invalid state, edge case needs warning
        }
    });
    return mappedStates;
}
exports.processPseudoStates = processPseudoStates;
function resolveStateType(stateDefinition, mappedStates, stateDefault, diagnostics, decl) {
    if (stateDefinition.type === 'function' && stateDefinition.nodes.length === 0) {
        resolveBooleanState(mappedStates, stateDefinition);
        diagnostics.warn(decl, exports.stateErrors.NO_STATE_TYPE_GIVEN(stateDefinition.value), {
            word: decl.value,
        });
        return;
    }
    if (stateDefinition.nodes.length > 1) {
        diagnostics.warn(decl, exports.stateErrors.TOO_MANY_STATE_TYPES(stateDefinition.value, (0, value_1.listOptions)(stateDefinition)), { word: decl.value });
    }
    const paramType = stateDefinition.nodes[0];
    const stateType = {
        type: paramType.value,
        arguments: [],
        defaultValue: postcss_value_parser_1.default
            .stringify(stateDefault)
            .trim(),
    };
    if (isCustomMapping(stateDefinition)) {
        mappedStates[stateDefinition.value] = stateType.type.trim().replace(/\\["']/g, '"');
    }
    else if (typeof stateType === 'object' && stateType.type === 'boolean') {
        resolveBooleanState(mappedStates, stateDefinition);
        return;
    }
    else if (paramType.type === 'function' && stateType.type in state_validators_1.systemValidators) {
        if (paramType.nodes.length > 0) {
            resolveArguments(paramType, stateType, stateDefinition.value, diagnostics, decl);
        }
        mappedStates[stateDefinition.value] = stateType;
    }
    else if (stateType.type in state_validators_1.systemValidators) {
        mappedStates[stateDefinition.value] = stateType;
    }
    else {
        diagnostics.warn(decl, exports.stateErrors.UNKNOWN_STATE_TYPE(stateDefinition.value, paramType.value), { word: paramType.value });
    }
}
function resolveArguments(paramType, stateType, name, diagnostics, decl) {
    const separatedByComma = (0, value_1.groupValues)(paramType.nodes);
    separatedByComma.forEach((group) => {
        const validator = group[0];
        if (validator.type === 'function') {
            const args = (0, value_1.listOptions)(validator);
            if (args.length > 1) {
                diagnostics.warn(decl, exports.stateErrors.TOO_MANY_ARGS_IN_VALIDATOR(name, validator.value, args), { word: decl.value });
            }
            else {
                stateType.arguments.push({
                    name: validator.value,
                    args,
                });
            }
        }
        else if (validator.type === 'string' || validator.type === 'word') {
            stateType.arguments.push(validator.value);
        }
    });
}
function isCustomMapping(stateDefinition) {
    return stateDefinition.nodes.length === 1 && stateDefinition.nodes[0].type === 'string';
}
function resolveBooleanState(mappedStates, stateDefinition) {
    const currentState = mappedStates[stateDefinition.type];
    if (!currentState) {
        mappedStates[stateDefinition.value] = null; // add boolean state
    }
    else {
        // TODO: warn with such name already exists
    }
}
// TRANSFORM
/* @deprecated */
exports.validateStateDefinition = (0, deprecation_1.wrapFunctionForDeprecation)(function (decl, meta, resolver, diagnostics) {
    if (decl.parent && decl.parent.type !== 'root') {
        const container = decl.parent;
        if (container.type !== 'atrule') {
            const parentRule = container;
            const selectorAst = (0, selector_1.parseSelectorWithCache)(parentRule.selector);
            if (selectorAst.length && selectorAst.length === 1) {
                const singleSelectorAst = selectorAst[0];
                const selectorChunk = singleSelectorAst.nodes;
                if (selectorChunk.length === 1 && selectorChunk[0].type === 'class') {
                    const className = selectorChunk[0].value;
                    const classMeta = features_1.CSSClass.get(meta, className);
                    const states = classMeta[`-st-states`];
                    if (classMeta && classMeta._kind === 'class' && states) {
                        for (const stateName in states) {
                            // TODO: Sort out types
                            const state = states[stateName];
                            if (state && typeof state === 'object') {
                                const res = validateStateArgument(state, meta, state.defaultValue || '', resolver, diagnostics, parentRule, true, !!state.defaultValue);
                                if (res.errors) {
                                    res.errors.unshift(`pseudo-state "${stateName}" default value "${state.defaultValue}" failed validation:`);
                                    diagnostics.warn(decl, res.errors.join('\n'), {
                                        word: decl.value,
                                    });
                                }
                            }
                        }
                    }
                    else {
                        // TODO: error state on non-class
                    }
                }
            }
        }
    }
}, { name: `validateStateDefinition` });
function validateStateArgument(stateAst, meta, value, resolver, diagnostics, rule, validateDefinition, validateValue = true) {
    const resolvedValidations = {
        res: resolveParam(meta, resolver, diagnostics, rule, value || stateAst.defaultValue),
        errors: null,
    };
    const { type: paramType } = stateAst;
    const validator = state_validators_1.systemValidators[paramType];
    try {
        if (resolvedValidations.res || validateDefinition) {
            const { errors } = validator.validate(resolvedValidations.res, stateAst.arguments, resolveParam.bind(null, meta, resolver, diagnostics, rule), !!validateDefinition, validateValue);
            resolvedValidations.errors = errors;
        }
    }
    catch (error) {
        // TODO: warn about validation throwing exception
    }
    return resolvedValidations;
}
exports.validateStateArgument = validateStateArgument;
function setStateToNode(states, meta, name, node, namespace, resolver, diagnostics, rule) {
    const stateDef = states[name];
    if (stateDef === null) {
        (0, selector_1.convertToClass)(node).value = createBooleanStateClassName(name, namespace);
    }
    else if (typeof stateDef === 'string') {
        // simply concat global mapped selector - ToDo: maybe change to 'selector'
        (0, selector_1.convertToInvalid)(node).value = stateDef;
    }
    else if (typeof stateDef === 'object') {
        resolveStateValue(meta, resolver, diagnostics, rule, node, stateDef, name, namespace);
    }
    delete node.nodes;
}
exports.setStateToNode = setStateToNode;
function resolveStateValue(meta, resolver, diagnostics, rule, node, stateDef, name, namespace) {
    const inputValue = node.nodes && node.nodes.length ? (0, selector_1.stringifySelector)(node.nodes) : ``;
    let actualParam = resolveParam(meta, resolver, diagnostics, rule, inputValue ? inputValue : stateDef.defaultValue);
    if (rule && !inputValue && !stateDef.defaultValue) {
        diagnostics.warn(rule, exports.stateErrors.NO_STATE_ARGUMENT_GIVEN(name, stateDef.type), {
            word: name,
        });
    }
    const validator = state_validators_1.systemValidators[stateDef.type];
    let stateParamOutput;
    try {
        stateParamOutput = validator.validate(actualParam, stateDef.arguments, resolveParam.bind(null, meta, resolver, diagnostics, rule), false, true);
    }
    catch (e) {
        // TODO: warn about validation throwing exception
    }
    if (stateParamOutput !== undefined) {
        if (stateParamOutput.res !== actualParam) {
            actualParam = stateParamOutput.res;
        }
        if (rule && stateParamOutput.errors) {
            stateParamOutput.errors.unshift(`pseudo-state "${name}" with parameter "${actualParam}" failed validation:`);
            diagnostics.warn(rule, stateParamOutput.errors.join('\n'), { word: actualParam });
        }
    }
    const strippedParam = (0, string_1.stripQuotation)(actualParam);
    (0, selector_1.convertToClass)(node).value = createStateWithParamClassName(name, namespace, strippedParam);
}
function resolveParam(meta, resolver, diagnostics, rule, nodeContent) {
    const defaultStringValue = '';
    const param = nodeContent || defaultStringValue;
    return (0, functions_1.evalDeclarationValue)(resolver, param, meta, rule, undefined, undefined, diagnostics);
}
function createBooleanStateClassName(stateName, namespace) {
    const escapedNamespace = (0, cssesc_1.default)(namespace, { isIdentifier: true });
    return `${escapedNamespace}${exports.booleanStateDelimiter}${stateName}`;
}
exports.createBooleanStateClassName = createBooleanStateClassName;
function createStateWithParamClassName(stateName, namespace, param) {
    const escapedNamespace = (0, cssesc_1.default)(namespace, { isIdentifier: true });
    return `${escapedNamespace}${exports.stateWithParamDelimiter}${stateName}${resolveStateParam(param, true)}`;
}
exports.createStateWithParamClassName = createStateWithParamClassName;
function resolveStateParam(param, escape = false) {
    const result = `${exports.stateMiddleDelimiter}${param.length}${exports.stateMiddleDelimiter}${param.replace(/\s/gm, '_')}`;
    // adding/removing initial `s` to indicate that it's not the first param of the identifier
    return escape ? (0, cssesc_1.default)(`s` + result, { isIdentifier: true }).slice(1) : result;
}
exports.resolveStateParam = resolveStateParam;
//# sourceMappingURL=pseudo-states.js.map